module.exports = __webpack_public_path__ + "img/topbar.976fd8f2.png";